module.exports = __webpack_public_path__ + "img/guideInfo2.83691a7f.png";